import script from "./HeaderUzafoundationNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderUzafoundationNavigation.vue?vue&type=script&setup=true&lang=js"

import "./HeaderUzafoundationNavigation.vue?vue&type=style&index=0&id=4770fabe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4770fabe"]])

export default __exports__